import React, { Component } from 'react';

import config from '../../config';
import { logError } from '../../util/log';
import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';

// Use ErrorBoyndary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
export class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // ChunkLoadErrors are expected after deploys (stale chunks) — everything
    // else is a real render crash that must reach Sentry.
    if (error?.name !== 'ChunkLoadError') {
      logError(error, 'render-error-boundary', {
        componentStack: errorInfo?.componentStack,
      });
    }
  }

  render() {
    // Render the fallback for EVERY caught error. Re-rendering the children
    // instead (the old non-chunk behavior) remounted the crashed page in an
    // endless loop: mount effects re-fired requests until the API rate limit
    // returned 429s (checkout speculate loop, 2026-07-24).
    if (this.state.error) {
      return <LoadableComponentErrorBoundaryPage />;
    }

    return this.props.children;
  }
}

// LoadableComponentErrorBoundary helps in situations
// where production build changes in the server and
// long-living client app tries to fetch code chunks that don't exist anymore.
// Note: in development mode with Hot Module Reloading (HMR) in use, this causes error loops.
const UseLoadableErrorBoundaryOnlyInProdutionMode = ({ children }) => {
  
  return config.dev ? (
    children
  ) : (
    <LoadableComponentErrorBoundary>{children}</LoadableComponentErrorBoundary>
  );
};
export default UseLoadableErrorBoundaryOnlyInProdutionMode;
